import * as api from '../api';

export const fetchAverageRating = (args: any): Promise<any> => {
  const {
    options: { siteId },
  } = args;
  return api.callGet(`/statistics/sites/${siteId}/average-rating`, args);
};
